var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCetraLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 36,
    viewBox: "0 0 48 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.8316 3.59698C39.0395 -1.19899 31.2755 -1.19899 26.4834 3.59698L30.4862 7.60302C33.0634 5.02368 37.2515 5.02368 39.8288 7.60302C42.406 10.1824 42.406 14.3738 39.8288 16.9531L35.689 21.1043C35.2058 18.8796 34.1024 16.7678 32.3789 15.0348L28.3761 19.0408C30.9533 21.6202 30.9533 25.8116 28.3761 28.3909C27.0874 29.6806 25.3961 30.3254 23.7128 30.3254C22.0215 30.3254 20.3382 29.6806 19.0496 28.3909C16.4723 25.8116 16.4723 21.6202 19.0496 19.0408L19.0174 19.0086L15.0468 15.0348C13.3232 16.7597 12.2198 18.8796 11.7366 21.1043L7.59688 16.9612C5.01962 14.3738 5.01962 10.1824 7.59688 7.60302C10.1741 5.02368 14.3622 5.02368 16.9395 7.60302L16.9717 7.57078L20.9342 3.60504C16.1421 -1.19093 8.37811 -1.19093 3.59407 3.60504C-1.19802 8.40101 -1.19802 16.1713 3.59407 20.9673L15.0226 32.405C17.4146 34.799 20.5557 36 23.6967 36C26.8377 36 29.9788 34.8071 32.3789 32.405L43.8074 20.9673C48.5995 16.1713 48.5995 8.40101 43.8074 3.60504L43.8316 3.59698Z",
    fill: "#000453"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12.1999C20 14.3923 21.7558 16.1737 23.9223 16.1737C26.0888 16.1737 27.8365 14.3923 27.8365 12.1999C27.8365 10.0074 26.0888 8.24219 23.9223 8.24219C21.7558 8.24219 20 10.0155 20 12.1999Z",
    fill: "#000453"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCetraLogo);
export default __webpack_public_path__ + "static/media/CetraLogo.203b94d3d0e835adc48769aeace4ec52.svg";
export { ForwardRef as ReactComponent };